import { c as _c } from "react/compiler-runtime";
import { forwardRef } from "react";
import { cn } from "@/lib/utils";
export const RealEstateDetailMobileContent = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement> & {
  scrollable?: boolean;
}>(function RealEstateDetailMobileContent(t0, ref) {
  const $ = _c(11);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      scrollable: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const scrollable = t1 === undefined ? true : t1;
  const t2 = scrollable ? "overflow-y-auto overflow-x-hidden" : "overflow-hidden";
  let t3;
  if ($[4] !== t2) {
    t3 = cn("bg-background h-full flex flex-col pb-5", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== props || $[8] !== ref || $[9] !== t3) {
    t4 = <div {...props} ref={ref} className={t3}>{children}</div>;
    $[6] = children;
    $[7] = props;
    $[8] = ref;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});
export function RealEstateDetailMobileSubcontent(t0) {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <div {...props} className="px-2 py-2  h-full gap-1 flex flex-col" data-sentry-component="RealEstateDetailMobileSubcontent" data-sentry-source-file="RealEstateDetailMobile.atoms.tsx">{children}</div>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}